var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TTableAdvance',{attrs:{"items":_vm.list,"fields":_vm.fields,"store":"warehouse.shipment_methods","resource":"","noFilter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }